module.exports = __webpack_public_path__ + "static/media/flights-poster.9f6c87c1.png";